import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SettingsService } from '../services/settings.service';
import { PatientService } from '../services/patient/patient.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const patientService = inject(PatientService)

  // check if authenticated
  if (!authService.isAuthenticated()) {
    console.log('User not authenticated, redirecting to login');
    authService.logout();
    router.navigate(['/login']);
    return false;
  }

  if (!patientService.getPatientId() || !patientService.getRegistrationCode()) {
    console.log('Patient ID or Registration Code missing, redirecting to login');
    authService.logout();
    router.navigate(['/login']);
    return false;
  }
  
  // check if registration status okay
  if (patientService.getRegistrationStatus() === 'REJECTED') {
    console.log('Patient registration rejected, redirecting to login');
    authService.logout();
    router.navigate(['/login']);
    return false;
  }

  return true;
};
